import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CommunityLeaderVisitingFellowFourTimesMonth = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Community leader visiting fellow: 4x/month" />
    </Box>
  );
};
